import { HIDE_MESSAGE, SHOW_MESSAGE } from "./actionType";

export const setShowMessageToState = payload => ({
  type: SHOW_MESSAGE,
  payload,
});
export const setHideMessageToState = () => ({
  type: HIDE_MESSAGE,
});

export const showMessage = (message,title = 'Information') => {
  return dispatch  => {
    dispatch(setShowMessageToState({message,title}));
  };
};
export const hideMessage = () => {
  return dispatch => {
    dispatch(setHideMessageToState());
  };
};
